<!-- 
Bar chart.

Unlike most of our components you must call the "display" method to trigger displaying the chart.
Call display inside a $nextTick - see ErrorsOverLastWeekChart for an example.
-->
<script>
import _ from "underscore";
import { Bar } from "vue-chartjs";
import { DefaultColors } from "@/components/common/chart/helper.js";
import { deepCopy } from "@/store/helpers";

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  methods: {
    display() {
      const data = deepCopy(this.chartData);
      _.each(data.datasets, d => {
        d.backgroundColor = d.backgroundColor || DefaultColors;
      });
      var options = this.chartOptions || {
        responsive: true,
        maintainAspectRatio: false,
        height: 100
      };
      options.legend = options.legend || {};
      options.legend.display = options.legend.display || false;
      this.renderChart(data, options);
    },
    isEmpty(data) {
      var isEmpty = true;
      if (data && data.datasets && data.datasets[0].data) {
        isEmpty = _.every(data.datasets[0].data, v => {
          return v === 0;
        });
      }
      return isEmpty;
    }
  }
};
</script>
